import { render } from "./OrthopedicAssessmentModal.vue?vue&type=template&id=54242ced&scoped=true"
import script from "./OrthopedicAssessmentModal.vue?vue&type=script&lang=js"
export * from "./OrthopedicAssessmentModal.vue?vue&type=script&lang=js"

import "./OrthopedicAssessmentModal.vue?vue&type=style&index=0&id=54242ced&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54242ced"]])

export default __exports__